module.exports = __webpack_public_path__ + "img/cover-2@2x.7b9ff3f7.png";